export const findKeyRecursivelyInObject = (obj, targetKey) => {
	if (obj === null || typeof obj !== 'object') {
		return null;
	}
	if (targetKey in obj) {
		return obj[targetKey];
	}
	for (const key in obj) {
		if (obj.hasOwnProperty(key)) {
			const result = findKeyRecursivelyInObject(obj[key], targetKey);
			if (result !== null) {
				return result;
			}
		}
	}
	return null;
};

export const createRandomNumber = (maxNumber)=>{
	return Math.floor(Math.random() * maxNumber) || 0
}